import {createReducer} from 'redux-act';
import {fetchWeeklyPrizeModalSuccess, clearWeeklyPrizeModal, type IWeeklyPrizeModal} from 'modules/actions/weeklyPrizeModal';

interface IErrorReducer {
	modal?: IWeeklyPrizeModal['modals'][number];
}

export const weeklyPrizeModal = createReducer<IErrorReducer>({}, {})
	.on(fetchWeeklyPrizeModalSuccess, (state, payload) => ({
		...state,
		modal: payload,
	}))
	.on(clearWeeklyPrizeModal, () => ({}));
